import styled from 'styled-components'

export const PageText = styled.div`
    padding: ${(props) => props.padding ? props.padding : "30px 0px"};
  `